// extracted by mini-css-extract-plugin
module.exports = {"head":"page_head__LQUhs","boxList":"page_boxList__QqLpE"};